import { object, number, string, mixed } from "yup";

export interface ClinicBillingDataResourceNew {
  type: {
    id: 1 | 2; // company type from API enum [1,2]
  } | null;
  firstName: string | null;
  lastName: string | null;
  companyName: string | null;
  tin: string | null; // tax identification number (NIP)
  vat: number | null;
  country: string;
  postcode: string | null;
  city: string | null;
  streetName: string | null;
  streetNumber: string | null;
  houseNumber: string | null;
}

export const clinicBillingDataResourceNewSchema = object({
  type: object({ id: mixed<1 | 2>().oneOf([1, 2]).required() })
    .nullable()
    .default(null),
  firstName: string().nullable().default(null),
  lastName: string().nullable().default(null),
  companyName: string().nullable().default(null),
  tin: string().nullable().default(null),
  vat: number().nullable().default(null),
  country: string().required(),
  postcode: string().nullable().default(null),
  city: string().nullable().default(null),
  streetName: string().nullable().default(null),
  streetNumber: string().nullable().default(null),
  houseNumber: string().nullable().default(null),
});
